export default "__VITE_ASSET__BN2X6zl$__"